import React, { useState, useEffect } from "react";
import "./integrations.css";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { globalFont } from "../../utils/RepeatFunctions/Schedule";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { BsCheckCircle } from "react-icons/bs";
import { Div1, ModalShow, ModalCont } from "../PatientPortalSettings/styles";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../../popups/GetStartedPopup";

export default function EmailIntegrationModal({
  onClose,
  onSuccess,
  mode,
  isIntegrationStep4,
  onNextStep4,
  onBackStep4,
  showReminderIntro5,
  onReminderBack,
  onReminderNext,
}) {
  const initialState = {
    email: "",
    password: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  const [mailError, setMailError] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [AlertMsg, setAlertMsg] = useState("");
  const [isConnected, setIsConnected] = useState(false);

  /* ---------------- GET Existing Email Config ---------------- */

  // useEffect(() => {
  //   if (mode === "edit") {
  //     getEmailConfig();
  //   } else {
  //     setFormData(initialState);
  //   }
  // }, [mode]);

  useEffect(() => {
    if (mode === "edit" || isIntegrationStep4) {
      getEmailConfig();
    } else {
      setFormData(initialState);
      setIsConnected(false);
    }
  }, [mode, isIntegrationStep4]);

  const getEmailConfig = () => {
    axiosInstance
      .get("/vozo/NotificationSetting")
      .then((res) => {
        let data = Decrypt_Value(res.data, "vozo");

        const email = data.find((d) => d.gl_name === "Notification_EMAIL");
        const password = data.find((d) => d.gl_name === "Notification_PASS");

        // setFormData({
        //   email: email?.gl_value || "",
        //   password: password?.gl_value || "",
        // });

        const connected = !!email?.gl_value && !!password?.gl_value;

        setFormData({
          email: email?.gl_value || "",
          password: password?.gl_value || "",
        });

        setIsConnected(connected);
      })
      .catch((err) => console.log(err));
  };
  /* ---------------- Handle Change ---------------- */

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!value.trim()) {
        setMailError("Email is required");
      } else if (!regex.test(value)) {
        setMailError("Please enter a valid email address");
      } else {
        setMailError("");
      }
    }

    if (name === "password") {
      if (!value.trim()) {
        setPasswordError("Password is required");
      } else {
        setPasswordError("");
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* ---------------- Close Modal ---------------- */

  const handleClose = () => {
    setFormData(initialState);
    setShowPassword(false);
    setIsConnected(false);
    onClose();
  };

  /* ---------------- Save Email Config ---------------- */

  const handleSubmit = async () => {
    let hasError = false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email.trim()) {
      setMailError("Email is required");
      hasError = true;
    } else if (!emailRegex.test(formData.email)) {
      setMailError("Please enter a valid email address");
      hasError = true;
    } else {
      setMailError("");
    }

    if (!formData.password.trim()) {
      setPasswordError("Password is required");
      hasError = true;
    } else if (formData.password.length < 16) {
      setPasswordError("Password must be at least 16 characters");
      hasError = true;
    } else {
      setPasswordError("");
    }

    if (hasError) return;

    try {
      const payload = Encrypt_Value(
        {
          email: formData.email,
          password: formData.password,
        },
        "vozo",
      );

      const res = await axiosInstance.post("/vozo/modules/testemail", payload);

      let data = Decrypt_Value(res.data, "vozo");

      if (data.status === "error") {
        setPasswordError("Authentication failed. Use your Gmail App Password ");
        return;
      }

      const article = [
        {
          glname: "Notification_EMAIL",
          glindex: "0",
          glvalue: formData.email,
        },
        {
          glname: "Notification_PASS",
          glindex: "0",
          glvalue: formData.password,
        },
      ];

      let encrypted = Encrypt_Value(article, "vozo");
      await axiosInstance.put("/vozo/settingsecurity", encrypted);

      // setAlertMsg("Connected successfully");

      // setModalAlerShow(true);

      // setTimeout(() => {
      //   setModalAlerShow(false);

      //   onSuccess && onSuccess(); // parent refresh
      //   handleClose(); // modal close
      // }, 2000);
      setIsConnected(true);

      if (!isIntegrationStep4) {
        setAlertMsg("Connected successfully");
        setModalAlerShow(true);
      }
      setTimeout(() => {
        // setModalAlerShow(false);
        if (!isIntegrationStep4) {
          setModalAlerShow(false);
        }

        onSuccess && onSuccess();

        if (isIntegrationStep4) {
          onNextStep4 && onNextStep4();
        } else {
          handleClose();
        }
      }, 2000);
    } catch (err) {
      console.log(err);
      setPasswordError("Something went wrong. Please try again.");
    }
  };
  useEffect(() => {
    if (isIntegrationStep4) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isIntegrationStep4]);

  const isPopupOpen = !!isIntegrationStep4 || !!showReminderIntro5;
  const isAccountSetupEmailIntegrationOpen =
    !!isIntegrationStep4 || !!showReminderIntro5;
  const popupTitle = isIntegrationStep4
    ? "Configure Email Integration"
    : "Configure Appointment Reminder";
  const popupBullets = isIntegrationStep4
    ? [
        'When click on "Connect" button for Email a configuration popup will open.',
        'Enter the required configuration details and click on the "Connect" button to link the configuration.',
      ]
    : [
        "In the Email Configuration popup enter the required details.",
        'Now click on the "Connect" button to confirm the configuration.',
      ];
  const popupStep = isIntegrationStep4 ? 4 : 5;
  const popupTotalSteps = showReminderIntro5 ? 6 : 13;
  const popupOnNext = isIntegrationStep4 ? onNextStep4 : onReminderNext;
  const popupOnBack = isIntegrationStep4 ? onBackStep4 : onReminderBack;

  return (
    <>
      <div className="integration-modal-overlay">
        <Popup
          offset={[5, 0]}
          content={
            <GetStartedPopup
              title={popupTitle}
              bullets={popupBullets}
              currentStep={popupStep}
              totalSteps={popupTotalSteps}
              onNext={popupOnNext}
              onBack={popupOnBack}
              onClose={() => {
                if (onClose) onClose();
              }}
              width="340px"
            />
          }
          open={isPopupOpen}
          trigger={
            <div
              style={{ fontFamily: globalFont }}
              className="modal-container-email"
            >
              {/* Header */}
              <Modal.Header closeButton className="p-8" onHide={handleClose}>
                <Modal.Title>Email Reminder Configuration</Modal.Title>
              </Modal.Header>

              {/* Body */}
              <div className="integration-modal-body">
                <form autoComplete="off">
                  {/* Email */}
                  <div className="input-group1">
                    <label>Appointment Reminder Email</label>

                    <input
                      type="email"
                      name="email"
                      className="email-input"
                      value={formData.email}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {mailError && (
                      <div className="errormessage">{mailError}</div>
                    )}
                  </div>

                  {/* Password */}
                  <div className="input-group1">
                    <label>Appointment Reminder Password</label>

                    <div className="password-wrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="email-input"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="new-password"
                      />

                      {showPassword ? (
                        <FaRegEyeSlash
                          className="eye-icon"
                          onClick={() => setShowPassword(false)}
                        />
                      ) : (
                        <FaRegEye
                          className="eye-icon"
                          onClick={() => setShowPassword(true)}
                        />
                      )}
                    </div>
                    {passwordError && (
                      <div className="errormessage">{passwordError}</div>
                    )}
                  </div>
                </form>

                <p className="help-text">
                  Add your email credentials to enable automatic reminder
                  emails.
                  <br />
                  Need help? Check the{" "}
                  <a
                    href="https://support.google.com/accounts/answer/185833"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Gmail App Password Guide
                  </a>
                </p>
              </div>

              {/* Footer */}
              <div className="integration-modal-footer">
                <button
                  className="integration-cancel-btn"
                  onClick={handleClose}
                >
                  Cancel
                </button>

                {/* <button className="integration-connect-btn" onClick={handleSubmit}>
                  Connect
                </button> */}
                <button
                  className="integration-connect-btn"
                  onClick={handleSubmit}
                  disabled={isIntegrationStep4 && isConnected}
                >
                  {isIntegrationStep4 && isConnected ? "Connected" : "Connect"}
                </button>
              </div>
            </div>
          }
          position="left center"
        />
      </div>
      {ModalAlerShow && (
        <ModalShow show={ModalAlerShow}>
          <Div1 position="relative" dis="flex" margin="0 auto" top="-5%">
            <ModalCont>
              <BsCheckCircle />
              <span>{AlertMsg}</span>
            </ModalCont>
          </Div1>
        </ModalShow>
      )}
    </>
  );
}
